import { createSlice } from '@reduxjs/toolkit'
import { getSkuListForExtrapolationFiltersAsync } from 'src/services/costModelling/skuShouldCostWorkbench.services'

export const initialSelectedFilters = {
  vendorDetails: {
    vendorId: [],
    vendorName: [],
    vendorType: [],
  },
  skuProduct: {
    l1: [],
    l2: [],
    l3: [],
    productType: [],
    htsCode: [],
  },
  uploadDetails: {
    uploadedFrom: null,
    uploadedTo: null,
    uploadedBy: [],
  },
  ltmSpend: [0, 0],
  po_eligible: null,
  ifa_shortlisting: null,
}
const initialState = {
  selected: initialSelectedFilters,
  options: {
    vendorId: [],
    vendorName: [],
    vendorType: [],
    country: [],
    l1: [],
    l2: [],
    l3: [],
    variant: [],
    productType: [],
    htsCode: [],
    uploadedBy: [],
    uploadedTo: null,
    uploadedFrom: null,
    skuPrimaryId: [],
    poCurrency: [],
    ltmSpend: { min_ltm_spend: 0, max_ltm_spend: 0 },
    skuSimulationCount: { all_skus: 0, without_simulation: 0, with_simulation: 0 },
  },
  loading: false,
}

export const skuListForExtrapolationSlice = createSlice({
  name: 'sku-list-for-extrapolation-slice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getSkuListForExtrapolationFiltersAsync.pending, (state) => {
        state.loading = true
      })
      .addCase(getSkuListForExtrapolationFiltersAsync.fulfilled, (state, action) => {
        const {
          vendorId,
          vendorName,
          vendorType,
          country,
          l1,
          l2,
          l3,
          variant,
          productType,
          htsCode,
          uploadedBy,
          skuPrimaryId,
          poCurrency,
          dateRange,
          ltmSpend,
          skuSimulationCount,
        } = action.payload.data
        state.options = {
          vendorId: vendorId ?? [],
          vendorName: vendorName ?? [],
          vendorType: vendorType ?? [],
          l1: l1 ?? [],
          l2: l2 ?? [],
          l3: l3 ?? [],
          variant: variant ?? [],
          productType: productType ?? [],
          htsCode: htsCode ?? [],
          uploadedFrom: dateRange?.min_date ?? null,
          uploadedTo: dateRange?.max_date ?? null,
          uploadedBy: uploadedBy ?? [],
          skuPrimaryId: skuPrimaryId ?? [],
          poCurrency: poCurrency ?? [],
          ltmSpend: ltmSpend ?? { min_ltm_spend: 0, max_ltm_spend: 0 },
          skuSimulationCount: skuSimulationCount ?? {
            all_skus: 0,
            without_simulation: 0,
            with_simulation: 0,
          },
        }
        state.loading = false
      })
      .addCase(getSkuListForExtrapolationFiltersAsync.rejected, (state) => {
        state.loading = false
        state.options = initialState.options
      })
  },
  reducers: {
    setAppliedFilterSection: (state, action) => {
      state.selected = { ...action.payload }
    },
    setFiltersOptions: (state, action) => {
      state.options = { ...action.payload }
    },
    resetAppliedFilterSection: (state) => {
      state.selected = initialSelectedFilters
    },
  },
})

export const { setAppliedFilterSection, resetAppliedFilterSection, setFiltersOptions } =
  skuListForExtrapolationSlice.actions

export default skuListForExtrapolationSlice.reducer
